import NewAxiosInstance from "../../../api/api";
import { ILogin, IVerifyOtp } from "../../../types/authTypes";

export const loginRequestApi = async (data: ILogin) => {
  return await NewAxiosInstance().post(`/auth/signin`, data);
};

export const verifyOtpApi = async (data: IVerifyOtp) => {
  return await NewAxiosInstance().post(`/auth/verifyotp`, data);
};
export const userMeApi = async () => {
  return await NewAxiosInstance().get(`/user/me`);
};
